// @ts-nocheck
/**
 * Use this component If you want to render a text coming from an editor (like the one used in resource detail).
 * Why we are creating a new component and not reusing the existing one (RawHTMLWrapper)?
 * Because in this component we will add styles for `all` html-tags like:
 * - h1, h2, h3, h...
 * - li, ul, ol,
 * - checkbox, select
 * - etc...
 * The RawHTMLWrapper is used to render the course description.
 * I tried to reuse the RawHTMLWrapper component but I failed miserably...
 * ...because the font-size was conflicting with the font-size coming from the editor.
 */
import styled from 'styled-components';
import {
  primaryText,
  white,
  secondaryMain,
  secondaryLight,
} from 'crehana-ui/styles/colors';
import transition from 'crehana-ui/styles/transition';

const HTMLFromEditors = styled.div<{ isDark?: boolean }>`
  font-family: Poppins, Arial, sans-serif !important;
  font-size: 16px;
  line-height: 24px;
  color: ${({ isDark }) => (isDark ? white : primaryText)};
  p {
    padding: 8px 0;
  }
  img {
    display: block;
    max-width: 100% !important;
    margin: 16px auto;
  }
  strong,
  b {
    font-family: Poppins, Arial, sans-serif !important;
    font-weight: 700;
  }
  em,
  i {
    font-style: italic;
  }
  ul {
    padding: 0 16px;
    margin-left: 4px;
  }
  li {
    list-style: disc;
  }
  a {
    font-family: Poppins, Arial, sans-serif !important;
    font-weight: 800;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: ${secondaryMain};
    transition: ${transition('color')};
    &:hover {
      color: ${secondaryLight};
    }
  }
  h1,
  h2,
  h3,
  h4 {
    line-height: 1.5;
    font-family: Poppins, Arial, sans-serif !important;
    font-weight: bold;
    letter-spacing: 0.1px;
  }
`;

export default HTMLFromEditors;
